import * as React from 'react';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TTextFieldCharacterCountLabel = {
  characterCount: number;
  maxLength: number;
  charsRemainingText?: string;
};

const TextFieldCharacterCountLabel = ({ characterCount = 0, maxLength = 0 }: TTextFieldCharacterCountLabel) => {
  const conditionalProps = filterConditionalKeyValues({
    states: characterCount > maxLength && 'errored',
  });

  const label = `${characterCount}/${maxLength}`;
  return (
    <Box {...conditionalProps} as="span" parent="TextField" name="characterCountAmount">
      {label}
    </Box>
  );
};

export default TextFieldCharacterCountLabel;
